import React from "react";
import { useNavigate } from "react-router-dom";
import { PreviewDrawer } from "@ippon/shared-components";
import RepairDetailPage from "../../../pages/Repairs/Detail/detail";

interface Props {
  open: boolean;
  onClose: () => void;
  repairId: string | null;
  propertyId?: string;
  propertyName?: string;
}

/**
 * Notion 風プレビュードロワー: 修繕詳細ページの中身をそのままドロワーに埋め込む。
 *
 * - 背景の物件詳細は操作可能なまま
 * - 左端ドラッグでリサイズ、ESC で閉じる
 * - 「全画面」ボタンで `/repairs/:id` に遷移
 */
const RepairDetailDrawer: React.FC<Props> = ({
  open,
  onClose,
  repairId,
  propertyId,
  propertyName,
}) => {
  const navigate = useNavigate();

  const openPage = () => {
    if (!repairId) return;
    navigate(`/repairs/${repairId}`, {
      state: {
        propName: propertyName,
        propertyId: propertyId,
        fromSource: "repairs",
      },
    });
    onClose();
  };

  return (
    <PreviewDrawer open={open} onClose={onClose} onExpand={openPage}>
      {repairId && (
        // key で repairId 変更時に再マウント。別の修繕へ切り替えても
        // ドロワーは開いたまま中身だけ差し替わり、フェッチ中はローディングを表示する
        // (key 無しだと前の修繕データが残ったまま無音で入れ替わる)。
        <RepairDetailPage key={repairId} overrideRepairId={repairId} embedded />
      )}
    </PreviewDrawer>
  );
};

export default RepairDetailDrawer;
